export default __webpack_public_path__ + "static/media/FloristoPaslaugos.1d809652.svg";